interface ServiceHeroProps {
  title: string;
  subtitle: string;
  description: string;
}

const ServiceHero = ({ title, subtitle, description }: ServiceHeroProps) => {
  return (
    <section className="relative min-h-[60vh] flex items-center justify-center px-6 lg:px-12 py-24 lg:py-32 bg-background">
      <div className="max-w-5xl mx-auto text-center">
        <p className="text-xs font-cta font-semibold tracking-[0.2em] uppercase text-muted-foreground mb-6">
          {subtitle}
        </p>
        <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-headline font-bold tracking-tight text-primary mb-8 leading-[0.95]">
          {title}
        </h1>
        <p className="text-lg md:text-xl lg:text-2xl font-body text-text-secondary max-w-3xl mx-auto leading-relaxed">
          {description}
        </p>
      </div>
    </section>
  );
};

export default ServiceHero;